import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from '../services/loading.service';

/**
 * Functional HTTP interceptor that tracks in-flight requests using LoadingService.
 * Increments on request, decrements on response/error (using finalize).
 * Emits true when there are in-flight requests, false when none.
 */
export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loadingService = inject(LoadingService);
  loadingService.increment();
  return next(req).pipe(
    finalize((): void => {
      loadingService.decrement();
    })
  );
};